import API from 'app/gamma/src/api';
import React from 'react';
import { MemberResponse } from 'app/gamma/src/types/responses';
import styles from './MoonshotInviteTeamMembers.less';
import { Spinner } from 'app/src/components/Spinner';
import { useFeatureFlag } from '@trello/feature-flag-client';
import { forNamespace } from 'app/common/lib/util/i18n';

const format = forNamespace(['moonshot', 'invitations']);

const MemberMultiSelectAutocompleteComponent = require('app/scripts/views/member/member-multi-select-autocomplete-component');

const onMemberSearchFetch = (
  query: string,
  idOrganization = '',
): Promise<MemberResponse[]> => {
  if (query.length > 2) {
    return API.client.searchMembers({
      query: query,
      idOrganization,
    });
  } else {
    return Promise.resolve([]);
  }
};

interface MoonshotInviteTeamMembersProps {
  orgId: string;
  setInvitationMessage: (message: string) => void;
  invitationMessage: string;
  isInvitingMembers: boolean;
  updateMembers: (action: object) => void;
  selectedMembers: MemberResponse[];
  orgName: string;
  // This allows the ability to override the search query
  // for things like tests and storybook
  onMemberSearch?: typeof onMemberSearchFetch;
}

export const MoonshotInviteTeamMembers: React.FC<MoonshotInviteTeamMembersProps> = ({
  orgId,
  orgName,
  onMemberSearch = onMemberSearchFetch,
  setInvitationMessage,
  invitationMessage,
  isInvitingMembers,
  updateMembers,
  selectedMembers,
}) => {
  const messageEnabledFlag = useFeatureFlag(
    'enable-invite-email-message',
    false,
  );

  if (messageEnabledFlag) {
    setInvitationMessage(format('invitation message', { orgName }));
  }

  return (
    <div className={styles.inviteTeamMembers}>
      <h2>
        {format('invite members heading part 1')}
        <em>{format('invite members heading part 2')}</em>
      </h2>
      <MemberMultiSelectAutocompleteComponent
        submitAlwaysEnabled
        fullWidthButton
        shouldFocusOnSelectMemberOption
        displayDetails
        displayUsername
        hideDefaultButton
        placeholder={format('members input placeholder')}
        emptySearchText={format('member not found messaging')}
        submitText={
          isInvitingMembers ? (
            <Spinner centered />
          ) : (
            format('invite members submit button')
          )
        }
        onAutocompleteSearch={(query: string) => onMemberSearch(query, orgId)}
        onSelectMemberOption={(members: MemberResponse | MemberResponse[]) => {
          if (members instanceof Array) {
            members.map((member) => updateMembers({ type: 'add', member }));
          } else {
            updateMembers({ type: 'add', member: members });
          }
        }}
        onRemoveMemberOption={(removedIndex: number) => {
          updateMembers({ type: 'remove', memberIndex: removedIndex });
        }}
        selectedOptions={selectedMembers}
      >
        <p className={styles.small}>
          <strong>{format('invite members tip part 1')}</strong>{' '}
          {format('invite members tip part 2')}
        </p>
        {messageEnabledFlag && (
          <>
            <h3>{format('invitation message heading')}</h3>
            <textarea
              value={invitationMessage}
              onChange={(event) => {
                setInvitationMessage(event.target.value);
              }}
              maxLength={500}
            />
          </>
        )}
        <div className={styles.buttonSpacer} />
      </MemberMultiSelectAutocompleteComponent>
    </div>
  );
};
